import User from '@/models/user'
import api from '@/lib/hippo'
import Vue from 'vue'
import Setting from '@/models/setting';
import Resource from '@/models/resource';
import FurthestVisitedPage from '@/models/furthest_visited_page';
import UserSource from '@/models/user_source';

function initialState() {
    return {
        users: {},
        shared_files:{},
        currentUser: new User({}),
        settings: {},
        furthest_page: {},
        user_sources: {},
        theme: 'color'
    };
}

const state = initialState;

const getters = {
	currentUser: (state, rootGetters) => ((state.currentUser) ? state.currentUser : ((Object.keys(state.users).indexOf(rootGetters.currentUserId) != -1) ? state.users[rootGetters.currentUserId] : {})),
	matchedUsers: (state) => state.users
};

const actions = {
    userSignup ({rootGetters}, signup) {
        return new Promise((resolve, reject) => {
            api.signup(signup).then((response) => resolve(response)).catch((err) => reject(err) );
        });
    },
    userConfirm ({rootGetters}, hash) {
        return new Promise((resolve, reject) => {
            api.confirmation(hash).then((response) => resolve(true)).catch((err) => reject(err));
        });
    },
    userForgot ({rootGetters}, email) {
        return new Promise((resolve, reject) => {
            api.forgotAccount(email).then((response) => resolve(true)).catch((err) => reject(err));
        });
    },
    userPassword ({rootGetters}, data) {
        return new Promise((resolve, reject) => {
            api.changePassword(rootGetters.apiToken, data).then((response) => resolve(true)).catch((err) => reject(err));
        });
    },

    fetchMatchings({commit, state, rootGetters}) {
        return new Promise((resolve, reject) => {
            if (rootGetters.apiToken) {
                api.getUsers(rootGetters.apiToken)
                .then( (response) => {
                    commit ('setUsers', User.from(response.data) );
                    resolve(true);
                }).catch( (err) => reject(err) );
            } else reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
        });
    },
    fetchSettings ({commit, state, rootGetters}) {
        return new Promise((resolve, reject) => {
            if (rootGetters.apiToken) {
                api.getUserSettings(rootGetters.apiToken).then((response) => {
                    commit ('addSettings', Setting.from(response.data) );
                    resolve(true);
                }).catch( (err) => reject(err) );
            } else reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
        });
    },
    saveSetting ({commit, state, rootGetters, dispatch}, {setting, value}) {
        return new Promise((resolve, reject) => {
            if (rootGetters.apiToken) {
                api.putUserSetting(rootGetters.apiToken, setting, value).then((response) => {
                    dispatch ('fetchSettings');
                    resolve(true);
                }).catch((err) => reject(err));
            } else reject(new Error('You are no longer logged in.'));
        });
    },
    fetchUserSources ({ rootGetters, state, commit}) {
		return new Promise((resolve, reject) => {
			
				api.getUserSources()
					.then((response) => {
                        let user_sources = UserSource.from(response.data);
						commit('addUserSources', user_sources);
						resolve(true);
					}).catch( (err) => reject(err) );
		});
	},
    resetUsersState({commit}) {
        commit('resetState');
    },
    fetchSharedFiles ({ rootGetters, state, commit}, enrollment_id) {
		return new Promise((resolve, reject) => {
			if (rootGetters.apiToken) {
				api.getSharedFiles(rootGetters.apiToken, enrollment_id)
					.then((response) => {
						let files = Resource.from(response.data);
						commit('addSharedFiles', files);
						resolve(true);
					}).catch( (err) => reject(err) );
			} else reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
		});
	},
	addSharedFile ({dispatch, state, rootGetters}, {formData, enrollment_id}) {
		return new Promise((resolve, reject) => {
            if (rootGetters.apiToken) {
                api.postSharedFiles(rootGetters.apiToken, formData, enrollment_id)
                    .then((response) => {
                        dispatch ('fetchSharedFiles', enrollment_id);
                        resolve(true);
                }).catch((err) => reject(err));
            } else reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
        });
	},
    hideSharedFile ({dispatch, state, rootGetters}, {shared_file_id, enrollment_id}) {
		return new Promise((resolve, reject) => {
			if (rootGetters.apiToken && shared_file_id) {
				api.hideSharedFile(rootGetters.apiToken, shared_file_id, enrollment_id)
					.then((response) => {
						dispatch ('fetchSharedFiles', enrollment_id);
						resolve(true);
					}).catch( (err) => reject(err) );
			} else reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
		});
	},
    fetchFurthestPageView ({commit, state, rootGetters}, {client_id, enrol_id}) {
		return new Promise((resolve, reject) => {
            if (rootGetters.apiToken) {

                api.getFurthestPageView(rootGetters.apiToken, client_id, enrol_id)
				.then((response) => {
					if(response.data && response.data.data.attributes && response.data.data.attributes.p_type == "slideshows"){
						response.data.data.attributes.page_id = response.data.included[0].id
					}
					let page_view = (response.data == null) ? new FurthestVisitedPage({}) : FurthestVisitedPage.from(response.data)			
                    commit('setFurthestPage', {client_id: client_id, enrol_id: enrol_id, furthest_page: page_view} );			
                    resolve(true);
				}).catch( (err) => {
					if (err.response.status == 404) {
						let furthest_temp = new FurthestVisitedPage({})
						commit('setFurthestPage', {client_id: client_id, enrol_id: enrol_id, furthest_page: furthest_temp});	
						resolve(true);
					} else	
						reject(err) });
			} else reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
        });
	}
};

const mutations = {
    setUser: (state, user) => {
        Vue.set(state.users, user.id, user);
    },
    setUsers: (state, users) => {
        Vue.set(state, 'users', users);
    },
    addSettings: (state, settings) => {
        Vue.set(state, 'settings', settings);
    },
    setSetting: (state, setting) => {
        Vue.set(state.settings, setting[0].id, setting[0]);
    },
    addSharedFiles: (state, files ) => {
		//mapStoreActions.safetyCheck(state,['shared_files',client_id]);
		Vue.set(state, 'shared_files', files);
	},
    setFurthestPage: (state, {client_id, enrol_id, furthest_page}) => {
		if (!state.furthest_page) Vue.set(state, 'furthest_page', {});
		if (!state.furthest_page[client_id]) Vue.set(state.furthest_page, client_id, {});
		Vue.set(state.furthest_page[client_id], enrol_id, furthest_page);
    },
    addUserSources: (state, user_sources ) => {
		Vue.set(state, 'user_sources', user_sources);
	},
    resetState ( state ) {
        const s = initialState();
        Object.keys(s).forEach(key => {
            Vue.set(state, key, s[key]);
        });
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}
